import { render } from "./index.vue?vue&type=template&id=a85219fa"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a85219fa&lang=less"
script.render = render

export default script